<template>
    <kgr-form-scaffold
        :pending="pending"
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-club-employee-knowledge-data-provider
            :employee-id="employeeId"
            :callback="onEmployeeKnowledgeLoaded"
        >
            <div>
                <kgr-club-employee-knowledge-form
                    :employee-knowledge="employeeKnowledge"
                    :error="error"
                    @enter="updateKnowledge"
                />
            </div>
        </kgr-club-employee-knowledge-data-provider>

        <kgr-club-employee-trainer-licenses-data-provider
            v-slot="trainerLicenseScope"
            :employee-id="employeeId"
            :callback="onEmployeeTrainerLicensesLoaded"
        >
            <kgr-club-employee-trainer-licenses-form
                :trainer-licenses="trainerLicenses"
                :employee-id="employeeId"
                :club-id="clubId"
                @updated="onUpdate(trainerLicenseScope.reload)"
            />
        </kgr-club-employee-trainer-licenses-data-provider>

        <kgr-club-employee-spoken-languages-data-provider
            v-slot="languageScope"
            :employee-id="employeeId"
            :callback="onEmployeeSpokenLanguagesLoaded"
        >
            <kgr-club-employee-spoken-languages-form
                :spoken-languages="spokenLanguages"
                :employee-id="employeeId"
                @updated="onUpdate(languageScope.reload)"
            />
        </kgr-club-employee-spoken-languages-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import ClubEmployeeKnowledgeDataProvider from '../../components/data-provider/ClubEmployeeKnowledgeDataProvider.vue';
import ClubEmployeeKnowledgeForm from '../../components/employees/ClubEmployeeKnowledgeForm.vue';
import ClubEmployeeRepository from '../../js/repository/ClubEmployeeRepository';
import ClubEmployeeSpokenLanguagesDataProvider from '../../components/data-provider/ClubEmployeeSpokenLanguagesDataProvider.vue';
import ClubEmployeeSpokenLanguagesForm from '../../components/employees/spoken-languages/ClubEmployeeSpokenLanguagesForm.vue';
import ClubEmployeeTrainerLicensesDataProvider from '../../components/data-provider/ClubEmployeeTrainerLicensesDataProvider.vue';
import ClubEmployeeTrainerLicensesForm from '../../components/employees/trainer-licenses/ClubEmployeeTrainerLicensesForm.vue';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold.vue';

export default {
    name: 'EmployeeKnowledge',
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-club-employee-knowledge-data-provider': ClubEmployeeKnowledgeDataProvider,
        'kgr-club-employee-knowledge-form': ClubEmployeeKnowledgeForm,
        'kgr-club-employee-spoken-languages-data-provider': ClubEmployeeSpokenLanguagesDataProvider,
        'kgr-club-employee-spoken-languages-form': ClubEmployeeSpokenLanguagesForm,
        'kgr-club-employee-trainer-licenses-data-provider': ClubEmployeeTrainerLicensesDataProvider,
        'kgr-club-employee-trainer-licenses-form': ClubEmployeeTrainerLicensesForm,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        employeeId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            employeeKnowledge: null,
            spokenLanguages: [],
            trainerLicenses: [],
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        updateKnowledge(knowledge) {
            this.employeeKnowledge = knowledge;
            this.update();
        },
        update() {
            this.pending = true;
            ClubEmployeeRepository.updateKnowledgeData(this.employeeId, this.employeeKnowledge)
                .then(() => {
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
        onEmployeeKnowledgeLoaded(loadedEmployeeKnowledge) {
            this.employeeKnowledge = loadedEmployeeKnowledge;
        },
        onEmployeeSpokenLanguagesLoaded(loadedSpokenLanguages) {
            this.spokenLanguages = loadedSpokenLanguages;
        },
        onEmployeeTrainerLicensesLoaded(loadedTrainerLicenses) {
            this.trainerLicenses = loadedTrainerLicenses;
        },
        onUpdate(reload) {
            reload();
        },
    },
};
</script>

<style scoped>

</style>
